import React from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * SectionHeaderSkeleton - Skeleton placeholder matching SectionHeader layout.
 *
 * Three-column layout: title (left), view-toggle (center), export-button (right).
 * Styled to match SectionHeader's border-left accent, divider, and action.hover bg.
 */
const SectionHeaderSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      minHeight: 44,
      maxWidth: '90%',
      width: '100%',
      mx: 'auto',
      mb: 1,
      py: 0.75,
      px: 1.5,
      bgcolor: 'action.hover',
      borderRadius: '6px',
      borderBottom: 1,
      borderColor: 'divider',
      borderLeft: '3px solid',
      borderLeftColor: 'primary.main',
    }}
  >
    {/* Left: Title placeholder */}
    <Box sx={{ flex: '1 1 0', minWidth: 220, overflow: 'hidden' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <Skeleton variant="circular" width={20} height={20} />
        <Skeleton variant="text" width={150} height={22} />
      </Box>
      <Skeleton variant="text" width={130} height={12} />
    </Box>

    {/* Center: View toggle placeholder */}
    <Box sx={{ flex: '0 0 auto', display: 'flex', gap: 0.5, mx: 1 }}>
      {[...Array(3)].map((_, i) => (
        <Skeleton key={i} variant="rounded" width={64} height={28} sx={{ borderRadius: '14px' }} />
      ))}
    </Box>

    {/* Right: Export button placeholder */}
    <Box sx={{ flex: '1 1 0', display: 'flex', justifyContent: 'flex-end', minWidth: 92 }}>
      <Skeleton variant="rounded" width={80} height={30} sx={{ borderRadius: '4px' }} />
    </Box>
  </Box>
);

export default SectionHeaderSkeleton;
